import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { ShippingContainer, ShippingOption, ShippingImageContainer, ShippingText } from './styles'

const ShippingDetails = ({ frame }) => {
  const { fastclock, clock, undo, shipping, setup, returns } = useStaticQuery(graphql`
    query ShippingIconsQuery {
      fastclock: file(relativePath: { eq: "fastclock.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      clock: file(relativePath: { eq: "clock.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      undo: file(relativePath: { eq: "undo.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      shipping: file(relativePath: { eq: "shipping.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      setup: file(relativePath: { eq: "setup.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      returns: file(relativePath: { eq: "returns.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const SHIPPING_INFO = [
    {
      image: frame ? clock : setup,
      alt: 'clock',
      text: frame ? 'Standard delivery in 5-7 days' : 'Easy Setup in 10 Minutes or Less',
      frameText: 'Standard delivery in 5-7 days',
    },
    {
      image: frame ? fastclock : shipping,
      alt: 'speedy clock',
      text: frame ? 'Expedited delivery in 3-5 days' : 'Ships in 1-2 Business Days',
    },
    {
      image: frame ? undo : returns,
      alt: 'undo arrow',
      text: frame ? '4 month free returns' : '4-Month Free Returns',
    },
  ]

  return (
    <ShippingContainer frame={frame}>
      {SHIPPING_INFO.map((option, i) => (
        <ShippingOption frame={frame} key={i}>
          <ShippingImageContainer truck={option.alt === 'speedy clock' && !frame}>
            <GatsbyImage image={option.image.childImageSharp.gatsbyImageData} alt={option.alt} />
          </ShippingImageContainer>
          <ShippingText special={option.alt === 'checkmark' || option.alt === 'pricetag'}>
            {frame ? option.frameText || option.text : option.text}
          </ShippingText>
        </ShippingOption>
      ))}
    </ShippingContainer>
  )
}

export default ShippingDetails

ShippingDetails.propTypes = {
  frame: PropTypes.bool,
}
